/**
 * Created by koko on 06/04/2017.
 */
"use strict";

import "./jquery-globals";

import "./menus"; // menus

import "./filter";

import "./cookies";

import "./posts"; // read more

import "./menu-fix"; // menu fix



// WEBPACK FOOTER //
// ./js/dev/app.js